import React, { useEffect } from "react";
import "./../../../css/app.css";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import SurfModeButtons from "../readingView/surfmodebuttons";
import SurfDiagram from "../readingView/surfdiagram";
import Listview from "../readingView/dynamiclistviews";
import Tools from "../readingView/tools";
import Mqtt_statusBar from "../../../mqtt/mqtt_statusbar";
import { useHistory } from "react-router-dom";
import Chart from "../readingView/chart";
import { useLocation } from "react-router-dom";

export default function LiveDisplay(props) {
  //console.log(props.location.props);
  let client = mqtt_topics.mqttclientinstance;
  let mac = mqtt_topics.choosenmac; //"0-5b-96";
  const offlinetimeout = 60;
  const history = useHistory();
  const location = useLocation();

  client.on("connect", function () {
    //console.log("connected");
    //subscribe to still live monitoring
    client.subscribe(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.stillpresent_topic,
    );
  });

  client.on("message", handleMqttMessage);

  function handleMqttMessage(topic, message) {
    //console.log("message "+message);
    if (
      topic ==
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.stillpresent_topic
    ) {
      //console.log("recieved user presence");
      if (!mqtt_topics.busy_Requesting_Data) {
        returnuserpresence();
      } else {
        setTimeout(function () {
          returnuserpresence();
        }, mqtt_topics.timeouttotrytorequestmqttdata);
      }
    }
    mqtt_topics.lasttimegotlivedata = Math.floor(Date.now() / 1000);
  }

  const handleClick = () => history.push("/"); //need to overwrite device is offline later

  function returnuserpresence() {
    //only if display is shown
    if (window.location.pathname.includes("/ld")) {
      mqtt_topics.busy_Requesting_Data = true;
      //console.log("publish user presence");
      client.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        "User Alive",
      ); //@ '+new Date().toLocaleString()
      mqtt_topics.busy_Requesting_Data = false;
    }
  }

  useEffect(() => {
    mqtt_topics.categories_User_Iswatching = [
      '"Close ' + mqtt_topics.modetopic + '"',
      '"Close ' + mqtt_topics.diagram_topic + '"',
    ];
    const interval = setInterval(() => {
      keepcheckingifoffline();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  function keepcheckingifoffline() {
    let now = Math.floor(Date.now() / 1000);
    //console.log("diff "+(now - mqtt_topics.lasttimegotlivedata)+" now "+now+" last "+mqtt_topics.lasttimegotlivedata);
    if (now - mqtt_topics.lasttimegotlivedata > offlinetimeout) {
      document.getElementById("onlinedisplay").style.display = "none";
      document.getElementById("offlinedisplay").style.display = "block";
      //localStorage.setItem(props.mac + "_grid_time", now - 7 * 60);
    }
  }
  //when componenet unmount
  useEffect(
    () => () => {
      if (mqtt_topics.categories_User_Iswatching.length > 0) {
        client.publish(
          mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
          JSON.parse(
            JSON.stringify(
              '{ "' +
                mqtt_topics.finishedofalllivereadings +
                '" : [' +
                mqtt_topics.categories_User_Iswatching +
                "] }",
            ),
          ),
        );
        /*if (mac == "0-6c-74") {
          //mac for sas45k to close volsas
          client.publish(
            mqtt_topics.fixed_topic_part +
              "0-5c-98" +
              mqtt_topics.request_topic,
            JSON.parse(
              JSON.stringify(
                '{ "' +
                  mqtt_topics.finishedofalllivereadings +
                  '" : [' +
                  mqtt_topics.categories_User_Iswatching +
                  "] }"
              )
            )
          );
        }*/
        mqtt_topics.categories_User_Iswatching = [];
      }
      client.removeListener("message", handleMqttMessage);
    },
    [location],
  );

  useEffect(() => {
    //check if site is offline
    mqtt_topics.timeouttotrytorequestmqttdata = Math.floor(Date.now() / 1000);
    window.onbeforeunload = (e) => {
      // I'm about to refresh! do something...
      if (mqtt_topics.categories_User_Iswatching.length > 0) {
        client.publish(
          mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
          JSON.parse(
            JSON.stringify(
              '{ "' +
                mqtt_topics.finishedofalllivereadings +
                '" : [' +
                mqtt_topics.categories_User_Iswatching +
                "] }",
            ),
          ),
        );
        mqtt_topics.categories_User_Iswatching = [];
      }
    };
  }, []);

  function getStoredDeviceData(mac) {
    return {
      entered_pass: localStorage.getItem(`entered_pass_of_${mac}`),
      userpass: localStorage.getItem(`userpass_of_${mac}`),
      clientpass: localStorage.getItem(`clientpass_of_${mac}`),
      seniorpass: localStorage.getItem(`seniorpass_of_${mac}`),
      saspass: localStorage.getItem(`saspass_of_${mac}`),
    };
  }

  function getPasswordLevel() {
    const data = getStoredDeviceData(mac);
    //console.log(data);
    const { entered_pass, userpass, clientpass, seniorpass, saspass } = data;
    if (entered_pass == saspass) return "sas";
    if (entered_pass == seniorpass) return "senior";
    if (entered_pass == undefined || entered_pass == clientpass)
      return "client";
    if (entered_pass == userpass) return "user";

    return null;
  }
  const pl = getPasswordLevel();
  return (
    <React.Fragment>
      <div className="col">
        <Mqtt_statusBar />
        <div id="onlinedisplay" style={{ display: "block" }}>
          <SurfModeButtons mqttClient={client} passlevel={pl} />
          <SurfDiagram mqttClient={client} passlevel={pl} />
          <Chart mac={mac} mqttClient={client} from="display.js" />
          <Listview mqttClient={client}></Listview>
          {pl != "user" && (
            <>
              <hr className="hr" />
              <Tools mqttClient={client} passlevel={pl} />
            </>
          )}
        </div>
        <div
          id="offlinedisplay"
          className="row"
          style={{ display: "none", zindex: 99 }}
        >
          <div className="container" style={{ height: "100%", width: "100%" }}>
            <div className="col">
              {localStorage
                .getItem("designtype_of_" + mac)
                .toLocaleUpperCase() == "FSHYBRBS" && <Chart mac={mac} />}
              <div>
                <center>
                  <img
                    src={require("./../../../images/offline.gif")}
                    className="simpleloadingview"
                  />
                  <p>
                    <strong>
                      The site appears to be offline, try to refresh the page in
                      5 minutes.
                    </strong>
                  </p>
                  <a
                    href="#"
                    className="btn btn-primary"
                    onClick={() => handleClick()}
                  >
                    Back
                  </a>
                </center>
              </div>
            </div>
          </div>
        </div>
        &nbsp;
      </div>
    </React.Fragment>
  );
}
